/*
 * @Date: 2022-06-30 16:00:41
 * @LastEditors: rann01
 * @LastEditTime: 2022-11-11 16:27:30
 * @Description:
 */
// eslint-disable-next-line import/no-extraneous-dependencies
import inject from '@mypaas/compiler-dev/utils/inject'
import 'seajs-amd'

const globalInject = {
    ...inject,
}

export function defineInject(appInfo = {}) {
    const {
        appId,
        engineVersion,
        webapp_version: appAssetsVersion,
        apiDomain = '',
        fixedDpr = false,
        buildRem = true,
        businessEnv,
    } = appInfo

    window.__INJECT__ = {
        ...inject,
        buildMode: 'app,miniProgram,mobileSite',
        isMobileSite: true,
        appId,
        env: 'preview',
        engine: engineVersion,
        appAssetsVersion,
        fixedDpr,
        buildRem,
        businessEnv,
    }

    Object.defineProperty(window.__INJECT__, 'apiDomain', {
        get() {
            const key = 'sys_default_domain'
            if (!Array.isArray(businessEnv && businessEnv.variables)) {
                return apiDomain || ''
            }
            const variable = businessEnv.variables.find(item => item.variableKey === key)
            return (variable ? variable.variableValue : apiDomain) || ''
        },
    })

    if (businessEnv && typeof businessEnv === 'object') {
        Object.defineProperty(businessEnv, 'getVariable', {
            configurable: false,
            value(key, defaultValue) {
                const { variables } = businessEnv
                if (!Array.isArray(variables) || variables.length <= 0) return defaultValue
                const variable = variables.find(v => v.variableKey === key)
                return variable ? variable.variableValue : defaultValue
            },
        })
    }

    window.__PLUGINS__ = []

    window.define('@inject', window.__INJECT__)
    window.define('@plugins', window.__PLUGINS__)

    Reflect.ownKeys(window.__INJECT__).forEach(key => {
        globalInject[key] = window.__INJECT__[key]
    })
}

export function defineLocalSDK(engine) {
    window.__PaaS_local__ = {}
    window.__PaaS_local__.sdk = engine.sdk
    window.__PaaS_local__.extension = engine.extension
}

export default globalInject
